import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.priority-breakdown.title',
		defaultMessage: 'Priority breakdown',
		description: 'Title of the breakdown by priority summary section.',
	},
	description: {
		id: 'contextual-summary.project-summary.priority-breakdown.description',
		defaultMessage:
			"Get a holistic view of how work is being prioritized. <link>See what your team's been focusing on</link>",
		description: 'Description of the breakdown by priority summary section.',
	},
	emptyDescription: {
		id: 'contextual-summary.project-summary.priority-breakdown.empty-description',
		defaultMessage:
			'Get a holistic view of how work is being prioritized. <link>How to manage priorities for projects</link>',
		description:
			"Description of the breakdown by priority summary section, when there's no issues with priority.",
	},
	noPriorityLabel: {
		id: 'contextual-summary.project-summary.priority-breakdown.no-priority-label',
		defaultMessage: 'None',
		description: 'The label for the no priority bar on the breakdown of priority summary section.',
	},
});
